<script>
/* jshint esversion: 6 */
import {watch, computed, inject } from 'vue'; 
import './../func.common'; 
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default{
    name: 'DoubleInput',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'id': { type: String, default: ''}, 
        'schemaId': {type: Number, default: 0}, 
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'disabled': {type: Boolean},
		'hinted': {type:String},
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName1 = computed(() => {
            return props.model[props.schema.elements[0].model];
        });

        const helperName2 = computed(() => {
            return props.model[props.schema.elements[1].model];
        });

        watch(helperName1, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.elements[0].model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        });


        watch(helperName2, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.elements[1].model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        });
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .doubleInput(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
        )
        .row.justify-content-between
            .col-12(v-if="schema.label && schema.label.length > 0")
                label {{schema.label}}
            .form-group.fieldInput(v-for="item, index in schema.elements" 
                :class="item.size ? item.size : 'col-12'"
                :style="disabled === true ? 'cursor:not-allowed; opacity: 0.5': ''"
            )    
                .form-group.row.gx-3-align-items-left
                    .col-sm-12
                        label(
                            :for="item.labelId" 
                            v-if="item.label && item.label.length > 0"
                        ) 
                            |{{ item.label }}
                            span.redAst(v-if="item.required === true") *
                        br
                        input.form-control(
                            :id="item.labelId" 
                            :type="item.inputType" 
                            :name="item.model" 
                            :value="model[item.model]" 
                            v-model="model[item.model]" 
                            :class="schema.errorShow === true ? 'inputred' : ''" 
                            :style="disabled === true ? 'pointer-events:none': ''"
                        )
            .row.fieldInput.col-12
                .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
                .vueFormSmall.labelred(v-if="schema.errorShow === true")
                    font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                    | &nbsp;{{ schema.errorText[0] }}
</template>